import UserGroupMembershipsStore from '.';
import { Creating } from './Types';

interface GroupMembershipsOut {
  user_group_memberships: {
    user_group_id: string;
    user_ids: ReadonlyArray<number>;
  };
}

export const userGroupMembershipsEncoder = (
  store: UserGroupMembershipsStore,
  state: Creating,
): GroupMembershipsOut => ({
  user_group_memberships: {
    user_ids: store.participantsStore.checkedParticipants.map(
      (participantStore) => participantStore.resource.payload.id,
    ),
    user_group_id: state.selectedUserGroupId,
  },
});
